import { Modal } from 'react-bootstrap';

function UsernameModal({
  show,
  name,
  setName,
  nameErr,
  setNameErr,
  onSubmit,
  loading,
}) {
  return (
    <Modal
      show={show}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      centered
      className="usernameModal"
    >
      <Modal.Body>
        <h2 className="usernameModal__title">
          It seems you haven’t entered
          <br />
          your name yet
        </h2>
        <p className="usernameModal__copy">
          Your name will appear on the station displays you interacted with.
        </p>
        <label className="usernameModal__label" htmlFor="guest-name">
          Your name
        </label>
        <input
          id="guest-name"
          className="usernameModal__input"
          type="text"
          value={name}
          disabled={loading}
          placeholder="Enter your name"
          onChange={(event) => {
            setName(event.target.value);
            if (event.target.value.trim()) setNameErr('');
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !loading) {
              event.preventDefault();
              onSubmit();
            }
          }}
        />
        {nameErr ? <p className="usernameModal__error">{nameErr}</p> : null}
        <button
          type="button"
          className="usernameModal__submit"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? 'Saving…' : 'Submit'}
        </button>
      </Modal.Body>
    </Modal>
  );
}

export default UsernameModal;
